"use client";

import { useTranslations } from "@i18n/next";
import { useSearchParams } from "next/navigation";

export const ParishWelcomeMessage = () => {
  const searchParams = useSearchParams();
  const t = useTranslations();

  const parish = searchParams.get("community");

  return !!parish
    ? t("web_community_congrats_successfully_joined", { "0": parish })
    : t("web_community_congrats_successfully_joined_generic");
};
